// Generated by Kaizen Variable Export
// Every value below is a fully resolved literal.

export const tokens = {
  baseColorLight: {
    color: {
      black: "#000000",
      white: "#ffffff",
      neutral: {
        25: "#ffffff",
        50: "#fbfbfb",
        100: "#eeeeee",
        200: "#dadada",
        300: "#c4c4c4",
        400: "#acacac",
        500: "#929292",
        600: "#858585",
        700: "#737373",
        800: "#5d5d5d",
        900: "#464646",
        950: "#2e2e2e",
        975: "#222222"
      },
      purple: {
        /** brand-primary--dark */
        25: "#fdfbfd",
        50: "#fbf6fa",
        100: "#f4e5f2",
        200: "#e9cbe6",
        300: "#deacda",
        400: "#d289cc",
        500: "#bf65ba",
        /** brand-primary--light */
        600: "#b353af",
        700: "#9e3e9b",
        /** brand-primary */
        800: "#832a80",
        /** brand-primary--dark */
        900: "#642361",
        /** brand-primary--dark */
        950: "#441942",
        /** brand-primary--dark */
        975: "#351234"
      },
      cyanBlue: {
        /** brand-primary--dark */
        25: "#f8fcfe",
        50: "#f1f9fe",
        100: "#d7effc",
        200: "#addff9",
        300: "#78ccf6",
        400: "#41b5e9",
        500: "#1e9acc",
        /** brand-secondary */
        600: "#0e8cbc",
        700: "#0078a2",
        800: "#056285",
        900: "#074b66",
        /** brand-primary--dark */
        950: "#053245",
        /** brand-primary--dark */
        975: "#032635"
      },
      blue: {
        /** brand-primary--dark */
        25: "#fafcfe",
        50: "#f4f8fe",
        100: "#deecfc",
        200: "#bddafb",
        300: "#95c4fb",
        400: "#64abfb",
        500: "#068eff",
        600: "#0e82e8",
        700: "#0e70c8",
        800: "#0d5ba4",
        900: "#0a457e",
        /** brand-primary--dark */
        950: "#062e56",
        /** brand-primary--dark */
        975: "#042343"
      },
      transparent: "#ffffff00",
      lightCyanBlue: {
        /** brand-primary--dark */
        25: "#f9fcfd",
        50: "#f2f9fc",
        100: "#d6eef6",
        200: "#aadfee",
        300: "#77cce3",
        400: "#4fb3cd",
        /** brand-secondary--light */
        500: "#3f99b1",
        600: "#398ca1",
        700: "#31798b",
        800: "#286372",
        900: "#1d4b57",
        /** brand-primary--dark */
        950: "#12333b",
        /** brand-primary--dark */
        975: "#0c262d"
      },
      skyBlue: {
        /** brand-primary--dark */
        25: "#f9fcfe",
        50: "#f2f9fe",
        100: "#d6ecfc",
        200: "#a9d9fb",
        300: "#6ec3fb",
        400: "#03a9f4",
        500: "#0791d1",
        600: "#0a84bf",
        700: "#0b72a6",
        800: "#0a5e89",
        900: "#08486a",
        /** brand-primary--dark */
        950: "#053149",
        /** brand-primary--dark */
        975: "#032539"
      },
      navyBlue: {
        /** brand-primary--dark */
        25: "#f9fcfe",
        50: "#f3f9fe",
        100: "#dbeefc",
        200: "#b7def9",
        300: "#8bcbf6",
        400: "#5bb5ed",
        /** brand-secondary--dark */
        500: "#339bd7",
        600: "#238ec9",
        700: "#147bb0",
        800: "#096592",
        900: "#024d72",
        /** brand-primary--dark */
        950: "#00344f",
        /** brand-primary--dark */
        975: "#001a2a"
      },
      lavender: {
        /** brand-primary--dark */
        25: "#fcfbfd",
        50: "#f9f6fb",
        100: "#eee5f5",
        200: "#dfcced",
        300: "#ceafe4",
        400: "#bb8eda",
        500: "#a56bcb",
        600: "#9a58c3",
        700: "#874aac",
        800: "#6f3c8e",
        900: "#552e6d",
        /** brand-primary--dark */
        950: "#3a1f4b",
        /** brand-primary--dark */
        975: "#2d173b"
      },
      teal: {
        /** brand-primary--dark */
        25: "#f5fefc",
        50: "#ebfcf9",
        100: "#bff8ee",
        200: "#74f0de",
        300: "#42dbc9",
        400: "#2ac1b0",
        500: "#17a495",
        600: "#009688",
        700: "#098175",
        800: "#0d6a60",
        900: "#0c5049",
        /** brand-primary--dark */
        950: "#083630",
        /** brand-primary--dark */
        975: "#052924"
      },
      red: {
        /** brand-primary--dark */
        25: "#fefafa",
        50: "#fdf6f4",
        100: "#fbe3df",
        200: "#f9c7c0",
        300: "#f8a498",
        400: "#f6796a",
        500: "#f13b31",
        600: "#e7000b",
        700: "#c51916",
        800: "#a01d18",
        900: "#791b15",
        /** brand-primary--dark */
        950: "#53130e",
        /** brand-primary--dark */
        975: "#410d09"
      },
      amber: {
        /** brand-primary--dark */
        25: "#fefbf6",
        50: "#fdf8ee",
        100: "#fceccb",
        200: "#fdd98f",
        300: "#ffc107",
        400: "#e0a907",
        500: "#be900a",
        600: "#ad830d",
        700: "#95700e",
        800: "#795b0d",
        900: "#5b440a",
        /** brand-primary--dark */
        950: "#3c2c05",
        /** brand-primary--dark */
        975: "#2d2003"
      },
      yellow: {
        /** brand-primary--dark */
        25: "#fdfcf4",
        50: "#fcf8e8",
        100: "#f6ecb8",
        200: "#edd870",
        300: "#dbc03a",
        400: "#c1a821",
        500: "#a48e10",
        600: "#968100",
        700: "#816f05",
        800: "#6a5b08",
        900: "#504508",
        /** brand-primary--dark */
        950: "#362e06",
        /** brand-primary--dark */
        975: "#292203"
      },
      orange: {
        /** brand-primary--dark */
        25: "#fefbf8",
        50: "#fef6f2",
        100: "#fce6d8",
        200: "#fbccaf",
        300: "#faad79",
        400: "#f7872e",
        500: "#d96e00",
        600: "#c66404",
        700: "#ab5607",
        800: "#8c4607",
        900: "#6b3506",
        /** brand-primary--dark */
        950: "#482204",
        /** brand-primary--dark */
        975: "#381902"
      },
      green: {
        /** brand-primary--dark */
        25: "#f8fdf8",
        50: "#f1fbf1",
        100: "#d5f6d3",
        200: "#a7eda6",
        300: "#80dc80",
        400: "#66c567",
        500: "#50aa52",
        600: "#409d44",
        700: "#3b863d",
        800: "#326d34",
        900: "#265227",
        /** brand-primary--dark */
        950: "#183619",
        /** brand-primary--dark */
        975: "#112911"
      },
      lightGreen: {
        /** brand-primary--dark */
        25: "#fafdf7",
        50: "#f5faf0",
        100: "#e1f3d0",
        200: "#c1e99b",
        300: "#a4d96c",
        400: "#8bc34a",
        500: "#76a640",
        600: "#6c973b",
        700: "#5d8234",
        800: "#4b692a",
        900: "#38501f",
        /** brand-primary--dark */
        950: "#243413",
        /** brand-primary--dark */
        975: "#1a270c"
      },
      lime: {
        /** brand-primary--dark */
        25: "#fbfcf6",
        50: "#f6f9eb",
        100: "#e5efa9",
        200: "#cddc39",
        300: "#b8c630",
        400: "#a2ae2d",
        500: "#8a9529",
        600: "#7e8727",
        700: "#6d7523",
        800: "#59601c",
        900: "#434915",
        /** brand-primary--dark */
        950: "#2d310c",
        /** brand-primary--dark */
        975: "#222507"
      },
      indigo: {
        /** brand-primary--dark */
        25: "#fbfbfe",
        50: "#f6f7fe",
        100: "#e5e8fb",
        200: "#cbd2fa",
        300: "#aeb8f9",
        400: "#8f9afa",
        500: "#7076fa",
        600: "#615fff",
        700: "#5343f7",
        800: "#4430d5",
        900: "#3329a1",
        950: "#211d6d",
        /** brand-primary--dark */
        975: "#191557"
      },
      magenta: {
        /** brand-primary--dark */
        25: "#fdfafd",
        50: "#fcf5fb",
        100: "#f6e1f4",
        200: "#f0c1ed",
        300: "#f093ec",
        400: "#ff00ff",
        500: "#da12da",
        600: "#c714c7",
        700: "#ad10ad",
        800: "#8f0d8f",
        900: "#6f0a6e",
        /** brand-primary--dark */
        950: "#4c064c",
        /** brand-primary--dark */
        975: "#3c043c"
      },
      khaki: {
        /** brand-primary--dark */
        25: "#fcfbfa",
        50: "#faf8f6",
        100: "#f0ece5",
        200: "#e3dacc",
        300: "#d5c6af",
        400: "#c3b091",
        500: "#a89575",
        600: "#9a8769",
        700: "#857459",
        800: "#6c5e47",
        900: "#514634",
        /** brand-primary--dark */
        950: "#352e21",
        /** brand-primary--dark */
        975: "#282117"
      },
      slateBlue: {
        /** brand-primary--dark */
        25: "#fbfcfc",
        50: "#f7f8f9",
        100: "#e7ecef",
        200: "#d1dae1",
        300: "#b8c6d0",
        400: "#9db0bc",
        500: "#8398a6",
        600: "#768c9a",
        700: "#647a88",
        800: "#516572",
        900: "#3c4b55",
        /** brand-primary--dark */
        950: "#273137",
        /** brand-primary--dark */
        975: "#1c2429"
      },
      pink: {
        /** brand-primary--dark */
        25: "#fdfbfb",
        50: "#fcf6f6",
        100: "#f7e6e6",
        200: "#f1cecd",
        300: "#ecb1b0",
        400: "#e68f8f",
        500: "#d56e70",
        600: "#c66164",
        700: "#ad5154",
        800: "#8f4144",
        900: "#6d3133",
        /** brand-primary--dark */
        950: "#491f21",
        /** brand-primary--dark */
        975: "#381617"
      }
    }
  },
  baseColorDark: {
    color: {
      black: "#000000",
      white: "#ffffff",
      neutral: {
        25: "#161616",
        50: "#1e1e1e",
        100: "#2c2c2c",
        200: "#404040",
        300: "#595959",
        400: "#757575",
        500: "#949494",
        600: "#a0a0a0",
        700: "#b2b2b2",
        800: "#c6c6c6",
        900: "#dedede",
        950: "#f8f8f8",
        975: "#ffffff"
      },
      purple: {
        25: "#230a22",
        50: "#341233",
        100: "#541c52",
        200: "#832a80",
        300: "#9e3e9a",
        400: "#b858b3",
        500: "#cf7bc9",
        /** brand-primary--light */
        600: "#d38bce",
        700: "#daa1d5",
        /** brand-primary */
        800: "#e2b9de",
        /** brand-primary--dark */
        900: "#ecd3e9",
        950: "#f8eff7",
        975: "#fbf6fa"
      },
      cyanBlue: {
        25: "#021824",
        50: "#032432",
        100: "#04384d",
        200: "#035573",
        300: "#0078a2",
        400: "#0f91c2",
        500: "#2dade3",
        /** brand-secondary */
        600: "#44b7eb",
        700: "#67c5f2",
        800: "#91d4f7",
        900: "#bce4f9",
        950: "#e6f5fc",
        975: "#f2f9fe"
      },
      blue: {
        25: "#02162d",
        50: "#031e3b",
        100: "#042b52",
        200: "#053f74",
        300: "#06569d",
        400: "#0670cb",
        500: "#068eff",
        600: "#479cf8",
        700: "#6eaff8",
        800: "#96c4f8",
        900: "#bfdaf9",
        950: "#e9f2fc",
        975: "#f4f8fe"
      },
      transparent: "#ffffff00",
      lightCyanBlue: {
        25: "#06191e",
        50: "#0a2228",
        100: "#11313a",
        200: "#1b4854",
        300: "#276473",
        400: "#358397",
        /** brand-secondary--light */
        500: "#47a6bf",
        600: "#4fb3cd",
        700: "#69c2da",
        800: "#8dd2e6",
        900: "#bae3ef",
        950: "#e6f4f9",
        975: "#f2f9fc"
      },
      skyBlue: {
        25: "#021826",
        50: "#022032",
        100: "#042f47",
        200: "#054565",
        300: "#075e8a",
        400: "#087cb3",
        500: "#0c9de2",
        600: "#03a9f4",
        700: "#53b9f8",
        800: "#88cbf9",
        900: "#b8defa",
        950: "#e6f3fc",
        975: "#f3f9fe"
      },
      navyBlue: {
        25: "#021826",
        50: "#00344f",
        100: "#024161",
        200: "#06557c",
        300: "#106c9c",
        400: "#1f87bf",
        /** brand-secondary--dark */
        500: "#3ca4e1",
        600: "#50aee9",
        700: "#6fbdf1",
        800: "#95cef5",
        900: "#bee0f9",
        950: "#e7f4fc",
        975: "#f3f9fe"
      },
      lavender: {
        25: "#1d0d27",
        50: "#281434",
        100: "#3b1e4d",
        200: "#562d70",
        300: "#773f99",
        400: "#9a58c3",
        500: "#b37dd7",
        600: "#ba8cd9",
        700: "#c5a1df",
        800: "#d3b9e6",
        900: "#e2d3ee",
        950: "#f4eff8",
        975: "#f9f7fc"
      },
      teal: {
        25: "#021a17",
        50: "#042521",
        100: "#063731",
        200: "#085149",
        300: "#077166",
        400: "#009688",
        500: "#19b4a4",
        600: "#29bfaf",
        700: "#3ccfbe",
        800: "#59e1d0",
        900: "#8df1e2",
        950: "#d9faf4",
        975: "#ebfcf9"
      },
      red: {
        25: "#2c0604",
        50: "#3b0b07",
        100: "#55100c",
        200: "#7d1510",
        300: "#ae1411",
        400: "#e7000b",
        500: "#f75d4f",
        600: "#f57768",
        700: "#f69386",
        800: "#f7b1a6",
        900: "#f8cfc8",
        950: "#fceeeb",
        975: "#fef6f5"
      },
      amber: {
        25: "#1d1401",
        50: "#291d03",
        100: "#3d2c04",
        200: "#5a4308",
        300: "#7d5e0b",
        400: "#a67d0d",
        500: "#d4a00d",
        600: "#e5ad08",
        700: "#ffc107",
        800: "#fcd278",
        900: "#fbe2b1",
        950: "#fcf3e1",
        975: "#fdf7ec"
      },
      yellow: {
        25: "#1a1602",
        50: "#251f03",
        100: "#372e04",
        200: "#514605",
        300: "#716104",
        400: "#968100",
        500: "#b59c12",
        600: "#bfa721",
        700: "#cfb633",
        800: "#e0c852",
        900: "#eedd89",
        950: "#f9f3d4",
        975: "#fcf8e8"
      },
      orange: {
        25: "#250f01",
        50: "#311502",
        100: "#452003",
        200: "#622f03",
        300: "#854204",
        400: "#ac5703",
        500: "#d96e00",
        600: "#e67a1e",
        700: "#f39047",
        800: "#f7ad7d",
        900: "#f9cdb2",
        950: "#fcede4",
        975: "#fef6f2"
      },
      green: {
        25: "#091a09",
        50: "#0f250f",
        100: "#183819",
        200: "#255426",
        300: "#337635",
        400: "#409d44",
        500: "#57ba5a",
        600: "#65c367",
        700: "#76d177",
        800: "#8fe18f",
        900: "#b6eeb4",
        950: "#e5f8e4",
        975: "#f1fbf0"
      },
      lightGreen: {
        25: "#101906",
        50: "#17230a",
        100: "#243412",
        200: "#364d1c",
        300: "#4c6b29",
        400: "#658d37",
        500: "#81b446",
        600: "#8bc34a",
        700: "#9bd064",
        800: "#b0de84",
        900: "#ccebaf",
        950: "#ecf7e3",
        975: "#f4faef"
      },
      lime: {
        25: "#151703",
        50: "#1e2106",
        100: "#2c300b",
        200: "#414713",
        300: "#5b621b",
        400: "#788125",
        500: "#99a42e",
        600: "#a5b12e",
        700: "#b7c530",
        800: "#cddc39",
        900: "#dee994",
        950: "#f2f6de",
        975: "#f7faed"
      },
      indigo: {
        25: "#0f0c3c",
        50: "#16124e",
        100: "#221a73",
        200: "#3321aa",
        300: "#4925ef",
        400: "#615fff",
        500: "#808afc",
        600: "#8d98fa",
        700: "#a1acf8",
        800: "#b8c1f7",
        900: "#d2d8f9",
        950: "#eef1fc",
        975: "#f6f8fe"
      },
      magenta: {
        25: "#280228",
        50: "#350335",
        100: "#4b044a",
        200: "#6a066a",
        300: "#900990",
        400: "#bb0fbb",
        500: "#ea1eea",
        600: "#ff00ff",
        700: "#ee7eeb",
        800: "#eca8e8",
        900: "#f0cbee",
        950: "#f9edf8",
        975: "#fcf6fb"
      },
      khaki: {
        25: "#19150d",
        50: "#241e14",
        100: "#352d20",
        200: "#4f4432",
        300: "#6e5f47",
        400: "#917f61",
        500: "#b6a283",
        600: "#c3b091",
        700: "#cdbda4",
        800: "#d9cdba",
        900: "#e6dfd3",
        950: "#f5f2ee",
        975: "#f9f8f5"
      },
      slateBlue: {
        /** brand-primary--dark */
        25: "#11171a",
        50: "#1d252b",
        100: "#323f47",
        200: "#516572",
        300: "#647987",
        400: "#7a909e",
        500: "#94a8b6",
        600: "#9fb1bd",
        700: "#afbfc9",
        800: "#c2ced6",
        900: "#d8e0e5",
        /** brand-primary--dark */
        950: "#f0f3f5",
        /** brand-primary--dark */
        975: "#f6f8f9"
      },
      pink: {
        /** brand-primary--dark */
        25: "#260d0d",
        50: "#331314",
        100: "#491e1f",
        200: "#6a2e30",
        300: "#914144",
        400: "#bc595c",
        500: "#de7e7f",
        600: "#e68f8f",
        700: "#e8a5a4",
        800: "#ecbcbb",
        900: "#f2d5d4",
        /** brand-primary--dark */
        950: "#f9efef",
        /** brand-primary--dark */
        975: "#fcf6f6"
      }
    }
  },
  theme: {
    light: {
      fgColor: {
        default: "#00344f",
        muted: "#737373",
        disabled: "#acacac",
        emphasis: "#2e2e2e",
        onEmphasis: "#ffffff",
        neutral: "#5d5d5d",
        accent: "#0a5e89",
        done: "#7076fa",
        closed: "#737373",
        danger: "#a01d18",
        severe: "#c66404",
        attention: "#816f05",
        success: "#3b863d",
        open: "#50aa52",
        black: "#000000",
        white: "#ffffff",
        onInverse: "#ffffff",
        link: "#832a80",
        linkOnEmphasis: "#fbf6fa",
        primary: "#832a80",
        primaryMuted: "#d289cc",
        secondary: "#0078a2",
        secondaryMuted: "#1e9accb3"
      },
      bgColor: {
        default: "#fbfbfb",
        muted: "#ffffff73",
        inset: "#ffffff73",
        disabled: "#eeeeee",
        emphasis: "#2e2e2e",
        transparent: "#ffffff00",
        inverse: "#464646",
        neutralEmphasis: "#5d5d5d",
        neutralMuted: "#5d5d5d80",
        accentEmphasis: "#0a5e89",
        accentMuted: "#f2f9fe",
        successEmphasis: "#3b863d",
        successMuted: "#d5f6d3",
        openEmphasis: "#50aa52",
        openMuted: "#d5f6d3",
        closedEmphasis: "#737373",
        closedMuted: "#c4c4c4",
        dangerEmphasis: "#a01d18",
        dangerMuted: "#fbe3df",
        severeEmphasis: "#c66404",
        severeMuted: "#fce6d8",
        attentionEmphasis: "#dbc03a",
        attentionMuted: "#fcf8e8",
        doneEmphasis: "#7076fa",
        doneMuted: "#e5e8fb",
        black: "#000000",
        white: "#ffffff",
        backdrop: "#0000008c",
        primaryEmphasis: "#832a80",
        primaryMuted: "#f4e5f2",
        secondaryEmphasis: "#0078a2",
        secondaryMuted: "#1e9accb3"
      },
      borderColor: {
        default: "#2222221f",
        muted: "#2222221a",
        emphasis: "#2e2e2e",
        disabled: "#7373731a",
        transparent: "#ffffff00",
        doneEmphasis: "#7076fa",
        doneMuted: "#e5e8fb",
        closedEmphasis: "#737373",
        closedMuted: "#73737366",
        dangerEmphasis: "#a01d18",
        dangerMuted: "#a01d1866",
        severeEmphasis: "#c66404",
        severeMuted: "#c6640466",
        attentionEmphasis: "#816f05",
        attentionMuted: "#816f0566",
        successEmphasis: "#3b863d",
        successMuted: "#3b863d66",
        accentEmphasis: "#0a5e89",
        accentMuted: "#f2f9fe",
        openEmphasis: "#50aa52",
        openMuted: "#3b863d66",
        translucent: "#ffffff26",
        primary: "#832a80",
        primaryMuted: "#832a8066",
        secondary: "#0078a2",
        secondaryMuted: "#0078a266"
      },
      surface: {
        elevation0: "#ffffff",
        elevation1: "#ffffff",
        elevation2: "#ffffff",
        elevation3: "#ffffff",
        elevation4: "#ffffff",
        elevation5: "#ffffff",
        elevation6: "#ffffff"
      },
      control: {
        fgColor: {
          rest: "#00344f",
          placeholder: "#737373",
          disabled: "#acacac"
        },
        borderColor: {
          rest: "#2222221f",
          selected: "#ffffff",
          emphasis: "#2e2e2e",
          disabled: "#7373731a",
          success: "#3b863d",
          danger: "#a01d18",
          warning: "#816f05"
        },
        bgColor: {
          rest: "#ffffff",
          hover: "#dadada",
          active: "#eeeeee",
          selected: "#ffffff",
          disabled: "#eeeeee"
        },
        iconColor: {
          rest: "#737373",
          disabled: "#acacac"
        },
        checked: {
          fgColor: {
            rest: "#ffffff",
            disabled: "#ffffff"
          },
          borderColor: {
            rest: "#ffffff00",
            hover: "#ffffff00",
            active: "#ffffff00",
            disabled: "#ffffff00"
          },
          bgColor: {
            rest: "#0a5e89",
            hover: "#0a5e89",
            active: "#0a5e89",
            disabled: "#eeeeee"
          }
        },
        transparent: {
          borderColor: {
            rest: "#ffffff00",
            hover: "#ffffff00",
            active: "#ffffff00"
          },
          bgColor: {
            rest: "#ffffff00",
            hover: "#92929233",
            active: "#92929240",
            selected: "#9292921a",
            disabled: "#eeeeee"
          }
        },
        danger: {
          fgColor: {
            hover: "#a01d18",
            rest: "#a01d18"
          },
          bgColor: {
            active: "#fbe3df66",
            hover: "#fbe3df"
          }
        }
      },
      tooltip: {
        fgColor: "#ffffff",
        bgColor: "#2e2e2ecc"
      },
      mode: "light",
      lightMode: true,
      darkMode: false,
      focus: {
        outlineColor: "#832a80"
      },
      button: {
        primary: {
          borderColor: {
            rest: "#ffffff00",
            disabled: "#ffffff00",
            hover: "#ffffff00",
            active: "#ffffff00"
          },
          bgColor: {
            disabled: "#eeeeee",
            active: "#832a80",
            hover: "#642361",
            rest: "#832a80"
          },
          fgColor: {
            disabled: "#acacac",
            rest: "#ffffff"
          },
          shadow: {
            selected: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#2222224d"
            }
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#acacac"
          }
        },
        secondary: {
          fgColor: {
            rest: "#832a80",
            disabled: "#acacac",
            active: "#832a80",
            hover: "#642361"
          },
          bgColor: {
            selected: "#ffffff00",
            active: "#832a801f",
            hover: "#832a801a",
            rest: "#ffffff00",
            disabled: "#ffffff00"
          },
          borderColor: {
            active: "#bf65ba",
            hover: "#b353af",
            rest: "#deacda",
            disabled: "#7373731a"
          },
          shadow: {
            resting: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#2222220a"
            }
          },
          iconColor: {
            hover: "#642361",
            rest: "#832a80",
            disabled: "#acacac"
          }
        },
        tertiary: {
          bgColor: {
            disabled: "#ffffff00",
            active: "#832a801f",
            hover: "#832a801a",
            rest: "#ffffff00"
          },
          fgColor: {
            active: "#832a80",
            hover: "#832a80",
            rest: "#832a80",
            disabled: "#acacac"
          },
          borderColor: {
            selected: "#ffffff00",
            hover: "#ffffff00",
            active: "#ffffff00",
            disabled: "#ffffff00"
          },
          shadow: {
            selected: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#22222233"
            }
          },
          iconColor: {
            hover: "#832a80",
            rest: "#832a80",
            disabled: "#acacac"
          }
        },
        neutral: {
          fgColor: {
            hover: "#737373",
            rest: "#5d5d5d",
            disabled: "#acacac",
            active: "#5d5d5d"
          },
          borderColor: {
            hover: "#ffffff00",
            rest: "#ffffff00",
            disabled: "#ffffff00"
          },
          bgColor: {
            active: "#c4c4c4",
            hover: "#dadada",
            rest: "#ffffff00",
            disabled: "#ffffff00"
          },
          iconColor: {
            hover: "#737373",
            rest: "#5d5d5d",
            disabled: "#acacac"
          }
        },
        danger: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00"
          },
          bgColor: {
            active: "#a01d18",
            hover: "#791b15",
            rest: "#a01d18",
            disabled: "#eeeeee"
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#acacac"
          },
          fgColor: {
            active: "#ffffff",
            hover: "#ffffff",
            disabled: "#acacac",
            rest: "#ffffff"
          },
          shadow: {
            selected: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#22222233"
            }
          }
        },
        attention: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00"
          },
          bgColor: {
            active: "#dbc03a",
            hover: "#a48e10",
            rest: "#dbc03a",
            disabled: "#dbc03a26"
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#acacac"
          },
          fgColor: {
            active: "#2e2e2e",
            hover: "#2e2e2e",
            disabled: "#acacac",
            rest: "#2e2e2e"
          },
          shadow: {
            selected: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#22222233"
            }
          }
        },
        success: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00"
          },
          bgColor: {
            active: "#3b863d",
            hover: "#326d34",
            rest: "#3b863d",
            disabled: "#3b863d26"
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#acacac"
          },
          fgColor: {
            active: "#ffffff",
            hover: "#ffffff",
            disabled: "#acacac",
            rest: "#ffffff"
          },
          shadow: {
            selected: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#22222233"
            }
          }
        },
        accent: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00"
          },
          bgColor: {
            active: "#0a5e89",
            hover: "#08486a",
            rest: "#0a5e89",
            disabled: "#0a5e8926"
          },
          iconColor: {
            hover: "#ffffff",
            rest: "#ffffff",
            disabled: "#acacac"
          },
          fgColor: {
            active: "#ffffff",
            hover: "#ffffff",
            disabled: "#acacac",
            rest: "#ffffff"
          },
          shadow: {
            selected: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#22222233"
            }
          }
        },
        star: {
          iconColor: "#edd870"
        },
        inactive: {
          bgColor: "#eeeeee",
          fgColor: "#737373"
        }
      },
      sectionNavigation: {
        bgColor: "#ffffff"
      },
      display: {
        default: {
          outlined: {
            fgColor: {
              rest: "#5d5d5d",
              hover: "#2e2e2e",
              active: "#464646",
              disabled: "#acacac"
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#dadada",
              active: "#c4c4c4",
              disabled: "#ffffff00"
            },
            borderColor: {
              rest: "#858585",
              hover: "#737373",
              active: "#464646",
              disabled: "#7373731a"
            },
            iconColor: {
              rest: "#5d5d5d",
              hover: "#737373",
              active: "#737373",
              disabled: "#acacac"
            }
          },
          subtle: {
            fgColor: {
              rest: "#5d5d5d",
              hover: "#2e2e2e",
              active: "#464646",
              disabled: "#acacac"
            },
            bgColor: {
              rest: "#22222212",
              hover: "#2222222b",
              active: "#22222236",
              disabled: "#2222220d"
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00"
            },
            iconColor: {
              rest: "#5d5d5d",
              hover: "#2e2e2e",
              active: "#464646",
              disabled: "#acacac"
            }
          },
          bold: {
            bgColor: {
              rest: "#5d5d5d",
              hover: "#464646",
              active: "#2e2e2e",
              disabled: "#eeeeee"
            },
            borderColor: {
              rest: "#5d5d5d",
              hover: "#464646",
              active: "#2e2e2e",
              disabled: "#7373731a"
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac"
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac"
            }
          }
        },
        accent: {
          outlined: {
            fgColor: {
              rest: "#0a5e89",
              hover: "#08486a",
              active: "#08486a",
              disabled: "#acacac"
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#f2f9fe",
              active: "#d6ecfc",
              disabled: "#ffffff00"
            },
            borderColor: {
              rest: "#0a5e89",
              hover: "#08486a",
              active: "#08486a",
              disabled: "#7373731a"
            },
            iconColor: {
              rest: "#0a5e89",
              hover: "#08486a",
              active: "#08486a",
              disabled: "#acacac"
            }
          },
          subtle: {
            fgColor: {
              rest: "#0a5e89",
              hover: "#0a5e89",
              active: "#0a5e89",
              disabled: "#acacac"
            },
            bgColor: {
              rest: "#f2f9fe",
              hover: "#d6ecfc",
              active: "#a9d9fb",
              disabled: "#eeeeee"
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00"
            },
            iconColor: {
              rest: "#0a5e89",
              hover: "#0a5e89",
              active: "#0a5e89",
              disabled: "#acacac"
            }
          },
          bold: {
            bgColor: {
              rest: "#0a5e89",
              hover: "#08486a",
              active: "#08486a",
              disabled: "#eeeeee"
            },
            borderColor: {
              rest: "#0a5e89",
              hover: "#08486a",
              active: "#08486a",
              disabled: "#7373731a"
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac"
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac"
            }
          }
        },
        attention: {
          outlined: {
            fgColor: {
              rest: "#816f05",
              hover: "#816f05cc",
              active: "#816f05",
              disabled: "#acacac"
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#fcf8e8",
              active: "#f6ecb8",
              disabled: "#ffffff00"
            },
            borderColor: {
              rest: "#816f05",
              hover: "#816f05",
              active: "#6a5b08",
              disabled: "#7373731a"
            },
            iconColor: {
              rest: "#816f05",
              hover: "#816f05cc",
              active: "#816f05",
              disabled: "#acacac"
            }
          },
          subtle: {
            fgColor: {
              rest: "#816f05",
              hover: "#816f05",
              active: "#816f05",
              disabled: "#acacac"
            },
            bgColor: {
              rest: "#fcf8e8",
              hover: "#f6ecb8",
              active: "#edd870",
              disabled: "#eeeeee"
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00"
            },
            iconColor: {
              rest: "#816f05",
              hover: "#816f05",
              active: "#816f05",
              disabled: "#acacac"
            }
          },
          bold: {
            bgColor: {
              rest: "#dbc03a",
              hover: "#816f05",
              active: "#6a5b08",
              disabled: "#eeeeee"
            },
            borderColor: {
              rest: "#dbc03a",
              hover: "#816f05",
              active: "#6a5b08",
              disabled: "#7373731a"
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac"
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac"
            }
          }
        },
        danger: {
          outlined: {
            fgColor: {
              rest: "#a01d18",
              hover: "#e7000b",
              active: "#c51916",
              disabled: "#acacac"
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#fbe3df",
              active: "#f9c7c0",
              disabled: "#ffffff00"
            },
            borderColor: {
              rest: "#a01d18",
              hover: "#e7000b",
              active: "#c51916",
              disabled: "#7373731a"
            },
            iconColor: {
              rest: "#a01d18",
              hover: "#e7000b",
              active: "#c51916",
              disabled: "#acacac"
            }
          },
          subtle: {
            fgColor: {
              rest: "#a01d18",
              hover: "#a01d18",
              active: "#a01d18",
              disabled: "#acacac"
            },
            bgColor: {
              rest: "#fbe3df",
              hover: "#f9c7c0",
              active: "#f8a498",
              disabled: "#eeeeee"
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00"
            },
            iconColor: {
              rest: "#a01d18",
              hover: "#a01d18",
              active: "#a01d18",
              disabled: "#acacac"
            }
          },
          bold: {
            bgColor: {
              rest: "#a01d18",
              hover: "#e7000b",
              active: "#c51916",
              disabled: "#eeeeee"
            },
            borderColor: {
              rest: "#a01d18",
              hover: "#e7000b",
              active: "#c51916",
              disabled: "#7373731a"
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac"
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac"
            }
          }
        },
        success: {
          outlined: {
            fgColor: {
              rest: "#3b863d",
              hover: "#409d44",
              active: "#3b863d",
              disabled: "#acacac"
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#d5f6d3",
              active: "#a7eda6",
              disabled: "#ffffff00"
            },
            borderColor: {
              rest: "#3b863d",
              hover: "#409d44",
              active: "#3b863d",
              disabled: "#7373731a"
            },
            iconColor: {
              rest: "#3b863d",
              hover: "#409d44",
              active: "#3b863d",
              disabled: "#acacac"
            }
          },
          subtle: {
            fgColor: {
              rest: "#3b863d",
              hover: "#3b863d",
              active: "#3b863d",
              disabled: "#acacac"
            },
            bgColor: {
              rest: "#d5f6d3",
              hover: "#a7eda6",
              active: "#80dc80",
              disabled: "#eeeeee"
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00"
            },
            iconColor: {
              rest: "#3b863d",
              hover: "#3b863d",
              active: "#3b863d",
              disabled: "#acacac"
            }
          },
          bold: {
            bgColor: {
              rest: "#3b863d",
              hover: "#3b863d",
              active: "#326d34",
              disabled: "#eeeeee"
            },
            borderColor: {
              rest: "#3b863d",
              hover: "#3b863d",
              active: "#326d34",
              disabled: "#7373731a"
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac"
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac"
            }
          }
        },
        severe: {
          outlined: {
            fgColor: {
              rest: "#c66404",
              hover: "#ab5607",
              active: "#8c4607",
              disabled: "#acacac"
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#fce6d8",
              active: "#fbccaf",
              disabled: "#ffffff00"
            },
            borderColor: {
              rest: "#c66404",
              hover: "#ab5607",
              active: "#8c4607",
              disabled: "#7373731a"
            },
            iconColor: {
              rest: "#c66404",
              hover: "#ab5607",
              active: "#8c4607",
              disabled: "#acacac"
            }
          },
          subtle: {
            fgColor: {
              rest: "#c66404",
              hover: "#c66404",
              active: "#c66404",
              disabled: "#acacac"
            },
            bgColor: {
              rest: "#fce6d8",
              hover: "#fbccaf",
              active: "#faad79",
              disabled: "#eeeeee"
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00"
            },
            iconColor: {
              rest: "#c66404",
              hover: "#c66404",
              active: "#c66404",
              disabled: "#acacac"
            }
          },
          bold: {
            bgColor: {
              rest: "#c66404",
              hover: "#ab5607",
              active: "#8c4607",
              disabled: "#eeeeee"
            },
            borderColor: {
              rest: "#c66404",
              hover: "#ab5607",
              active: "#8c4607",
              disabled: "#7373731a"
            },
            fgColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac"
            },
            iconColor: {
              rest: "#ffffff",
              hover: "#ffffff",
              active: "#ffffff",
              disabled: "#acacac"
            }
          }
        }
      },
      tabs: {
        borderColor: {
          rest: "#ffffff00",
          disabled: "#ffffff00",
          hover: "#ffffff00",
          active: "#ffffff00",
          selected: "#832a80"
        },
        fgColor: {
          rest: "#832a80",
          disabled: "#acacac",
          hover: "#642361",
          active: "#832a80",
          selected: "#832a80"
        },
        bgColor: {
          rest: "#ffffff00",
          disabled: "#ffffff00",
          hover: "#832a8000",
          active: "#ffffff00",
          selected: "#ffffff00"
        }
      },
      toast: {
        fgColor: {
          rest: "#ffffff00",
          disabled: "#ffffff00",
          hover: "#ffffff00",
          active: "#ffffff00",
          selected: "#ffffff00"
        },
        bgColor: {
          rest: "#ffffff00",
          disabled: "#ffffff00",
          hover: "#ffffff00",
          active: "#ffffff00",
          selected: "#ffffff00"
        },
        borderColor: {
          rest: "#ffffff00",
          disabled: "#ffffff00",
          hover: "#ffffff00",
          active: "#ffffff00",
          selected: "#ffffff00"
        }
      }
    },
    dark: {
      fgColor: {
        default: "#e7f4fc",
        muted: "#b2b2b2",
        disabled: "#757575",
        emphasis: "#f8f8f8",
        onEmphasis: "#161616",
        neutral: "#c6c6c6",
        accent: "#88cbf9",
        done: "#808afc",
        closed: "#b2b2b2",
        danger: "#f7b1a6",
        severe: "#e67a1e",
        attention: "#e0c852",
        success: "#76d177",
        open: "#57ba5a",
        black: "#000000",
        white: "#ffffff",
        onInverse: "#161616",
        link: "#d38bce",
        linkOnEmphasis: "#341233",
        primary: "#d38bce",
        primaryMuted: "#b858b3",
        secondary: "#67c5f2",
        secondaryMuted: "#2dade3b3"
      },
      bgColor: {
        default: "#1e1e1e",
        muted: "#1616168c",
        inset: "#1616168c",
        disabled: "#2c2c2c",
        emphasis: "#f8f8f8",
        transparent: "#ffffff00",
        inverse: "#dedede",
        neutralEmphasis: "#c6c6c6",
        neutralMuted: "#c6c6c680",
        accentEmphasis: "#88cbf9",
        accentMuted: "#022032",
        successEmphasis: "#76d177",
        successMuted: "#183819",
        openEmphasis: "#57ba5a",
        openMuted: "#183819",
        closedEmphasis: "#b2b2b2",
        closedMuted: "#595959",
        dangerEmphasis: "#f7b1a6",
        dangerMuted: "#55100c",
        severeEmphasis: "#e67a1e",
        severeMuted: "#452003",
        attentionEmphasis: "#716104",
        attentionMuted: "#251f03",
        doneEmphasis: "#808afc",
        doneMuted: "#221a73",
        black: "#000000",
        white: "#ffffff",
        backdrop: "#0000008c",
        primaryEmphasis: "#d38bce",
        primaryMuted: "#541c52",
        secondaryEmphasis: "#67c5f2",
        secondaryMuted: "#2dade3b3"
      },
      borderColor: {
        default: "#ffffff1f",
        muted: "#ffffff1a",
        emphasis: "#f8f8f8",
        disabled: "#7373731a",
        transparent: "#ffffff00",
        doneEmphasis: "#808afc",
        doneMuted: "#221a73",
        closedEmphasis: "#b2b2b2",
        closedMuted: "#b2b2b266",
        dangerEmphasis: "#f7b1a6",
        dangerMuted: "#f7b1a666",
        severeEmphasis: "#e67a1e",
        severeMuted: "#e67a1e66",
        attentionEmphasis: "#e0c852",
        attentionMuted: "#71610466",
        successEmphasis: "#76d177",
        successMuted: "#76d17766",
        accentEmphasis: "#88cbf9",
        accentMuted: "#022032",
        openEmphasis: "#57ba5a",
        openMuted: "#76d17766",
        translucent: "#16161626",
        primary: "#d38bce",
        primaryMuted: "#d38bce66",
        secondary: "#67c5f2",
        secondaryMuted: "#67c5f266"
      },
      surface: {
        elevation0: "#161616",
        elevation1: "#161616",
        elevation2: "#161616",
        elevation3: "#161616",
        elevation4: "#161616",
        elevation5: "#161616",
        elevation6: "#161616"
      },
      control: {
        fgColor: {
          rest: "#e7f4fc",
          placeholder: "#b2b2b2",
          disabled: "#757575"
        },
        borderColor: {
          rest: "#ffffff1f",
          selected: "#161616",
          emphasis: "#f8f8f8",
          disabled: "#7373731a",
          success: "#76d177",
          danger: "#f7b1a6",
          warning: "#e0c852"
        },
        bgColor: {
          rest: "#161616",
          hover: "#404040",
          active: "#2c2c2c",
          selected: "#161616",
          disabled: "#2c2c2c"
        },
        iconColor: {
          rest: "#b2b2b2",
          disabled: "#757575"
        },
        checked: {
          fgColor: {
            rest: "#161616",
            disabled: "#161616"
          },
          borderColor: {
            rest: "#ffffff00",
            hover: "#ffffff00",
            active: "#ffffff00",
            disabled: "#ffffff00"
          },
          bgColor: {
            rest: "#88cbf9",
            hover: "#88cbf9",
            active: "#88cbf9",
            disabled: "#2c2c2c"
          }
        },
        transparent: {
          borderColor: {
            rest: "#ffffff00",
            hover: "#ffffff00",
            active: "#ffffff00"
          },
          bgColor: {
            rest: "#ffffff00",
            hover: "#94949433",
            active: "#94949440",
            selected: "#9494941a",
            disabled: "#2c2c2c"
          }
        },
        danger: {
          fgColor: {
            hover: "#f7b1a6",
            rest: "#f7b1a6"
          },
          bgColor: {
            active: "#55100c66",
            hover: "#55100c"
          }
        }
      },
      tooltip: {
        fgColor: "#161616",
        bgColor: "#f8f8f8cc"
      },
      mode: "light",
      lightMode: true,
      darkMode: false,
      focus: {
        outlineColor: "#d38bce"
      },
      button: {
        primary: {
          borderColor: {
            rest: "#ffffff00",
            disabled: "#ffffff00",
            hover: "#ffffff00",
            active: "#ffffff00"
          },
          bgColor: {
            disabled: "#2c2c2c",
            active: "#e2b9de",
            hover: "#ecd3e9",
            rest: "#e2b9de"
          },
          fgColor: {
            disabled: "#757575",
            rest: "#161616"
          },
          shadow: {
            selected: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#ffffff4d"
            }
          },
          iconColor: {
            hover: "#161616",
            rest: "#161616",
            disabled: "#757575"
          }
        },
        secondary: {
          fgColor: {
            rest: "#e2b9de",
            disabled: "#757575",
            active: "#e2b9de",
            hover: "#ecd3e9"
          },
          bgColor: {
            selected: "#ffffff00",
            active: "#d38bce1f",
            hover: "#d38bce1a",
            rest: "#ffffff00",
            disabled: "#ffffff00"
          },
          borderColor: {
            active: "#cf7bc9",
            hover: "#d38bce",
            rest: "#9e3e9a",
            disabled: "#7373731a"
          },
          shadow: {
            resting: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#ffffff0a"
            }
          },
          iconColor: {
            hover: "#ecd3e9",
            rest: "#e2b9de",
            disabled: "#757575"
          }
        },
        tertiary: {
          bgColor: {
            disabled: "#ffffff00",
            active: "#d38bce1f",
            hover: "#d38bce1a",
            rest: "#ffffff00"
          },
          fgColor: {
            active: "#e2b9de",
            hover: "#e2b9de",
            rest: "#e2b9de",
            disabled: "#757575"
          },
          borderColor: {
            selected: "#ffffff00",
            hover: "#ffffff00",
            active: "#ffffff00",
            disabled: "#ffffff00"
          },
          shadow: {
            selected: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#ffffff33"
            }
          },
          iconColor: {
            hover: "#e2b9de",
            rest: "#e2b9de",
            disabled: "#757575"
          }
        },
        neutral: {
          fgColor: {
            hover: "#b2b2b2",
            rest: "#c6c6c6",
            disabled: "#757575",
            active: "#c6c6c6"
          },
          borderColor: {
            hover: "#ffffff00",
            rest: "#ffffff00",
            disabled: "#ffffff00"
          },
          bgColor: {
            active: "#595959",
            hover: "#404040",
            rest: "#ffffff00",
            disabled: "#ffffff00"
          },
          iconColor: {
            hover: "#b2b2b2",
            rest: "#c6c6c6",
            disabled: "#757575"
          }
        },
        danger: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00"
          },
          bgColor: {
            active: "#f7b1a6",
            hover: "#f8cfc8",
            rest: "#f7b1a6",
            disabled: "#2c2c2c"
          },
          iconColor: {
            hover: "#161616",
            rest: "#161616",
            disabled: "#757575"
          },
          fgColor: {
            active: "#161616",
            hover: "#161616",
            disabled: "#757575",
            rest: "#161616"
          },
          shadow: {
            selected: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#ffffff33"
            }
          }
        },
        attention: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00"
          },
          bgColor: {
            active: "#716104",
            hover: "#a48e10",
            rest: "#716104",
            disabled: "#71610426"
          },
          iconColor: {
            hover: "#161616",
            rest: "#161616",
            disabled: "#757575"
          },
          fgColor: {
            active: "#161616",
            hover: "#161616",
            disabled: "#757575",
            rest: "#161616"
          },
          shadow: {
            selected: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#ffffff33"
            }
          }
        },
        success: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00"
          },
          bgColor: {
            active: "#76d177",
            hover: "#b0de84",
            rest: "#76d177",
            disabled: "#76d17726"
          },
          iconColor: {
            hover: "#161616",
            rest: "#161616",
            disabled: "#757575"
          },
          fgColor: {
            active: "#161616",
            hover: "#161616",
            disabled: "#757575",
            rest: "#161616"
          },
          shadow: {
            selected: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#ffffff33"
            }
          }
        },
        accent: {
          borderColor: {
            hover: "#ffffff00",
            active: "#ffffff00",
            rest: "#ffffff00"
          },
          bgColor: {
            active: "#88cbf9",
            hover: "#53b9f8",
            rest: "#88cbf9",
            disabled: "#88cbf926"
          },
          iconColor: {
            hover: "#161616",
            rest: "#161616",
            disabled: "#757575"
          },
          fgColor: {
            active: "#161616",
            hover: "#161616",
            disabled: "#757575",
            rest: "#161616"
          },
          shadow: {
            selected: {
              offsetX: 0,
              offsetY: 1,
              blur: 0,
              spread: 0,
              color: "#ffffff33"
            }
          }
        },
        star: {
          iconColor: "#514605"
        },
        inactive: {
          bgColor: "#2c2c2c",
          fgColor: "#b2b2b2"
        }
      },
      sectionNavigation: {
        bgColor: "#161616"
      },
      display: {
        default: {
          outlined: {
            fgColor: {
              rest: "#c6c6c6",
              hover: "#f8f8f8",
              active: "#dedede",
              disabled: "#757575"
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#404040",
              active: "#595959",
              disabled: "#ffffff00"
            },
            borderColor: {
              rest: "#a0a0a0",
              hover: "#b2b2b2",
              active: "#dedede",
              disabled: "#7373731a"
            },
            iconColor: {
              rest: "#c6c6c6",
              hover: "#b2b2b2",
              active: "#b2b2b2",
              disabled: "#757575"
            }
          },
          subtle: {
            fgColor: {
              rest: "#c6c6c6",
              hover: "#f8f8f8",
              active: "#dedede",
              disabled: "#757575"
            },
            bgColor: {
              rest: "#ffffff12",
              hover: "#ffffff2b",
              active: "#ffffff36",
              disabled: "#ffffff0d"
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00"
            },
            iconColor: {
              rest: "#c6c6c6",
              hover: "#f8f8f8",
              active: "#dedede",
              disabled: "#757575"
            }
          },
          bold: {
            bgColor: {
              rest: "#c6c6c6",
              hover: "#dedede",
              active: "#f8f8f8",
              disabled: "#2c2c2c"
            },
            borderColor: {
              rest: "#c6c6c6",
              hover: "#dedede",
              active: "#f8f8f8",
              disabled: "#7373731a"
            },
            fgColor: {
              rest: "#161616",
              hover: "#161616",
              active: "#161616",
              disabled: "#757575"
            },
            iconColor: {
              rest: "#161616",
              hover: "#161616",
              active: "#161616",
              disabled: "#757575"
            }
          }
        },
        accent: {
          outlined: {
            fgColor: {
              rest: "#88cbf9",
              hover: "#b8defa",
              active: "#b8defa",
              disabled: "#757575"
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#022032",
              active: "#042f47",
              disabled: "#ffffff00"
            },
            borderColor: {
              rest: "#88cbf9",
              hover: "#b8defa",
              active: "#b8defa",
              disabled: "#7373731a"
            },
            iconColor: {
              rest: "#88cbf9",
              hover: "#b8defa",
              active: "#b8defa",
              disabled: "#757575"
            }
          },
          subtle: {
            fgColor: {
              rest: "#88cbf9",
              hover: "#88cbf9",
              active: "#88cbf9",
              disabled: "#757575"
            },
            bgColor: {
              rest: "#022032",
              hover: "#042f47",
              active: "#054565",
              disabled: "#2c2c2c"
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00"
            },
            iconColor: {
              rest: "#88cbf9",
              hover: "#88cbf9",
              active: "#88cbf9",
              disabled: "#757575"
            }
          },
          bold: {
            bgColor: {
              rest: "#88cbf9",
              hover: "#b8defa",
              active: "#b8defa",
              disabled: "#2c2c2c"
            },
            borderColor: {
              rest: "#88cbf9",
              hover: "#b8defa",
              active: "#b8defa",
              disabled: "#7373731a"
            },
            fgColor: {
              rest: "#161616",
              hover: "#161616",
              active: "#161616",
              disabled: "#757575"
            },
            iconColor: {
              rest: "#161616",
              hover: "#161616",
              active: "#161616",
              disabled: "#757575"
            }
          }
        },
        attention: {
          outlined: {
            fgColor: {
              rest: "#e0c852",
              hover: "#e0c852cc",
              active: "#e0c852",
              disabled: "#757575"
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#251f03",
              active: "#372e04",
              disabled: "#ffffff00"
            },
            borderColor: {
              rest: "#e0c852",
              hover: "#cfb633",
              active: "#e0c852",
              disabled: "#7373731a"
            },
            iconColor: {
              rest: "#e0c852",
              hover: "#e0c852cc",
              active: "#e0c852",
              disabled: "#757575"
            }
          },
          subtle: {
            fgColor: {
              rest: "#e0c852",
              hover: "#e0c852",
              active: "#e0c852",
              disabled: "#757575"
            },
            bgColor: {
              rest: "#251f03",
              hover: "#372e04",
              active: "#514605",
              disabled: "#2c2c2c"
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00"
            },
            iconColor: {
              rest: "#e0c852",
              hover: "#e0c852",
              active: "#e0c852",
              disabled: "#757575"
            }
          },
          bold: {
            bgColor: {
              rest: "#716104",
              hover: "#cfb633",
              active: "#e0c852",
              disabled: "#2c2c2c"
            },
            borderColor: {
              rest: "#716104",
              hover: "#cfb633",
              active: "#e0c852",
              disabled: "#7373731a"
            },
            fgColor: {
              rest: "#161616",
              hover: "#161616",
              active: "#161616",
              disabled: "#757575"
            },
            iconColor: {
              rest: "#161616",
              hover: "#161616",
              active: "#161616",
              disabled: "#757575"
            }
          }
        },
        danger: {
          outlined: {
            fgColor: {
              rest: "#f7b1a6",
              hover: "#f57768",
              active: "#f69386",
              disabled: "#757575"
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#55100c",
              active: "#7d1510",
              disabled: "#ffffff00"
            },
            borderColor: {
              rest: "#f7b1a6",
              hover: "#f57768",
              active: "#f69386",
              disabled: "#7373731a"
            },
            iconColor: {
              rest: "#f7b1a6",
              hover: "#f57768",
              active: "#f69386",
              disabled: "#757575"
            }
          },
          subtle: {
            fgColor: {
              rest: "#f7b1a6",
              hover: "#f7b1a6",
              active: "#f7b1a6",
              disabled: "#757575"
            },
            bgColor: {
              rest: "#55100c",
              hover: "#7d1510",
              active: "#ae1411",
              disabled: "#2c2c2c"
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00"
            },
            iconColor: {
              rest: "#f7b1a6",
              hover: "#f7b1a6",
              active: "#f7b1a6",
              disabled: "#757575"
            }
          },
          bold: {
            bgColor: {
              rest: "#f7b1a6",
              hover: "#f57768",
              active: "#f69386",
              disabled: "#2c2c2c"
            },
            borderColor: {
              rest: "#f7b1a6",
              hover: "#f57768",
              active: "#f69386",
              disabled: "#7373731a"
            },
            fgColor: {
              rest: "#161616",
              hover: "#161616",
              active: "#161616",
              disabled: "#757575"
            },
            iconColor: {
              rest: "#161616",
              hover: "#161616",
              active: "#161616",
              disabled: "#757575"
            }
          }
        },
        success: {
          outlined: {
            fgColor: {
              rest: "#76d177",
              hover: "#65c367",
              active: "#76d177",
              disabled: "#757575"
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#183819",
              active: "#255426",
              disabled: "#ffffff00"
            },
            borderColor: {
              rest: "#76d177",
              hover: "#65c367",
              active: "#76d177",
              disabled: "#7373731a"
            },
            iconColor: {
              rest: "#76d177",
              hover: "#65c367",
              active: "#76d177",
              disabled: "#757575"
            }
          },
          subtle: {
            fgColor: {
              rest: "#76d177",
              hover: "#76d177",
              active: "#76d177",
              disabled: "#757575"
            },
            bgColor: {
              rest: "#183819",
              hover: "#255426",
              active: "#337635",
              disabled: "#2c2c2c"
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00"
            },
            iconColor: {
              rest: "#76d177",
              hover: "#76d177",
              active: "#76d177",
              disabled: "#757575"
            }
          },
          bold: {
            bgColor: {
              rest: "#76d177",
              hover: "#76d177",
              active: "#8fe18f",
              disabled: "#2c2c2c"
            },
            borderColor: {
              rest: "#76d177",
              hover: "#76d177",
              active: "#8fe18f",
              disabled: "#7373731a"
            },
            fgColor: {
              rest: "#161616",
              hover: "#161616",
              active: "#161616",
              disabled: "#757575"
            },
            iconColor: {
              rest: "#161616",
              hover: "#161616",
              active: "#161616",
              disabled: "#757575"
            }
          }
        },
        severe: {
          outlined: {
            fgColor: {
              rest: "#e67a1e",
              hover: "#f39047",
              active: "#f7ad7d",
              disabled: "#757575"
            },
            bgColor: {
              rest: "#ffffff00",
              hover: "#452003",
              active: "#622f03",
              disabled: "#ffffff00"
            },
            borderColor: {
              rest: "#e67a1e",
              hover: "#f39047",
              active: "#f7ad7d",
              disabled: "#7373731a"
            },
            iconColor: {
              rest: "#e67a1e",
              hover: "#f39047",
              active: "#f7ad7d",
              disabled: "#757575"
            }
          },
          subtle: {
            fgColor: {
              rest: "#e67a1e",
              hover: "#e67a1e",
              active: "#e67a1e",
              disabled: "#757575"
            },
            bgColor: {
              rest: "#452003",
              hover: "#622f03",
              active: "#854204",
              disabled: "#2c2c2c"
            },
            borderColor: {
              rest: "#ffffff00",
              hover: "#ffffff00",
              active: "#ffffff00",
              disabled: "#ffffff00"
            },
            iconColor: {
              rest: "#e67a1e",
              hover: "#e67a1e",
              active: "#e67a1e",
              disabled: "#757575"
            }
          },
          bold: {
            bgColor: {
              rest: "#e67a1e",
              hover: "#f39047",
              active: "#f7ad7d",
              disabled: "#2c2c2c"
            },
            borderColor: {
              rest: "#e67a1e",
              hover: "#f39047",
              active: "#f7ad7d",
              disabled: "#7373731a"
            },
            fgColor: {
              rest: "#161616",
              hover: "#161616",
              active: "#161616",
              disabled: "#757575"
            },
            iconColor: {
              rest: "#161616",
              hover: "#161616",
              active: "#161616",
              disabled: "#757575"
            }
          }
        }
      },
      tabs: {
        borderColor: {
          rest: "#ffffff00",
          disabled: "#ffffff00",
          hover: "#ffffff00",
          active: "#ffffff00",
          selected: "#e2b9de"
        },
        fgColor: {
          rest: "#e2b9de",
          disabled: "#757575",
          hover: "#ecd3e9",
          active: "#e2b9de",
          selected: "#e2b9de"
        },
        bgColor: {
          rest: "#ffffff00",
          disabled: "#ffffff00",
          hover: "#d38bce00",
          active: "#ffffff00",
          selected: "#ffffff00"
        }
      },
      toast: {
        fgColor: {
          rest: "#ffffff00",
          disabled: "#ffffff00",
          hover: "#ffffff00",
          active: "#ffffff00",
          selected: "#ffffff00"
        },
        bgColor: {
          rest: "#ffffff00",
          disabled: "#ffffff00",
          hover: "#ffffff00",
          active: "#ffffff00",
          selected: "#ffffff00"
        },
        borderColor: {
          rest: "#ffffff00",
          disabled: "#ffffff00",
          hover: "#ffffff00",
          active: "#ffffff00",
          selected: "#ffffff00"
        }
      }
    }
  },
  base: {
    size: {
      2: 2,
      4: 4,
      6: 6,
      8: 8,
      10: 10,
      12: 12,
      14: 14,
      16: 16,
      20: 20,
      22: 22,
      24: 24,
      28: 28,
      32: 32,
      36: 36,
      40: 40,
      44: 44,
      48: 48,
      56: 56,
      64: 64,
      72: 72,
      80: 80,
      88: 88,
      96: 96,
      112: 112,
      128: 128,
      negative2: -2,
      negative4: -4,
      negative6: -6,
      negative8: -8,
      negative10: -10,
      negative12: -12,
      negative14: -14,
      negative16: -16,
      negative20: -20,
      negative24: -24,
      negative28: -28,
      negative32: -32,
      negative36: -36,
      negative40: -40,
      negative44: -44,
      negative48: -48,
      negative56: -56,
      negative64: -64,
      negative72: -72,
      negative80: -80,
      negative88: -88,
      negative96: -96,
      negative112: -112,
      negative128: -128
    },
    typography: {
      fontStack: {
        sansSerif: "Montserrat",
        monospace: "Inconsolata",
        sansSerifDisplay: "Montserrat",
        system: "Montserrat"
      },
      text: {
        size: {
          /** Base text */
          xs: 10,
          /** Base text */
          s: 12,
          /** Base text */
          m: 14,
          /** Base text */
          l: 18,
          /** Base text */
          xl: 22,
          /** Base text */
          "2xl": 27,
          /** Base text */
          "3xl": 34,
          /** Base text */
          "4xl": 43
        },
        lineHeight: {
          /** base.typography.text.lineHeight.tight */
          tight: 1.25,
          /** base.typography.text.lineHeight.snug */
          snug: 1.375,
          /** base.typography.text.lineHeight.normal */
          normal: 1.5,
          /** base.typography.text.lineHeight.relaxed */
          relaxed: 1.625,
          /** base.typography.text.lineHeight.loose */
          loose: 1.75
        },
        weight: {
          light: 300,
          regular: 400,
          medium: 500,
          semibold: 600,
          bold: 700
        },
        title: {
          lineHeight: {
            /** base.typography.text.lineHeight.normal */
            xsmall: 1.5,
            /** base.typography.text.lineHeight.normal */
            small: 1.5,
            /** base.typography.text.lineHeight.relaxed */
            medium: 1.625,
            /** base.typography.text.lineHeight.normal */
            large: 1.5
          },
          fontSize: {
            xsmall: 14,
            small: 18,
            medium: 22,
            large: 27
          },
          fontWeight: {
            xsmall: 500,
            small: 600,
            medium: 600,
            large: 600
          },
          letterSpacing: {
            xsmall: 0,
            small: -0.2,
            medium: -0.2,
            large: -0.2
          }
        },
        display: {
          fontWeight: 600,
          fontFamily: "Montserrat",
          fontSize: 43,
          /** base.typography.text.lineHeight.snug */
          lineHeight: 1.375,
          letterSpacing: -0.2
        },
        body: {
          fontWeight: 400,
          fontSize: {
            /** Base text */
            small: 12,
            /** Base text */
            medium: 14,
            /** Base text */
            large: 18
          },
          lineHeight: {
            /** base.typography.text.lineHeight.relaxed */
            small: 1.625,
            /** base.typography.text.lineHeight.normal */
            medium: 1.5,
            /** base.typography.text.lineHeight.normal */
            large: 1.5
          },
          letterSpacing: {
            /** Base text */
            small: 0,
            /** Base text */
            medium: 0,
            /** Base text */
            large: 0
          }
        },
        monospace: {
          fontFamily: "Inconsolata",
          fontWeight: 400,
          fontSize: {
            /** Base text */
            small: 12,
            /** Base text */
            medium: 14,
            /** Base text */
            large: 18
          },
          lineHeight: {
            /** base.typography.text.lineHeight.normal */
            small: 1.5,
            /** base.typography.text.lineHeight.normal */
            medium: 1.5,
            /** base.typography.text.lineHeight.normal */
            large: 1.5
          },
          letterSpacing: {
            /** Base text */
            small: 0,
            /** Base text */
            medium: 0,
            /** Base text */
            large: 0
          }
        },
        caption: {
          fontWeight: 400,
          fontSize: 12,
          /** base.typography.text.lineHeight.tight */
          lineHeight: 1.25,
          letterSpacing: 0.3
        },
        overline: {
          fontFamily: "Montserrat",
          fontWeight: 400,
          fontSize: 14,
          /** base.typography.text.lineHeight.normal */
          lineHeight: 1.5,
          letterSpacing: 1
        },
        subtitle: {
          fontSize: {
            medium: 22,
            small: 18
          },
          fontWeight: {
            medium: 500,
            small: 500
          },
          letterSpacing: {
            medium: 0,
            small: 0
          },
          lineHeight: {
            /** base.typography.text.lineHeight.normal */
            medium: 1.5,
            /** base.typography.text.lineHeight.normal */
            small: 1.5
          }
        }
      },
      fontSize: 14
    }
  },
  functional: {
    size: {
      borderWidth: {
        default: 1,
        thin: 1,
        thick: 2,
        thicker: 4
      },
      space: {
        xxsmall: 2,
        xsmall: 4,
        small: 6,
        medium: 8,
        large: 12,
        xlarge: 16
      },
      breakpoint: {
        xsmall: 320,
        small: 480,
        medium: 768,
        large: 1024,
        xlarge: 1440
      },
      boxShadow: {
        thin: 0
      },
      borderRadius: {
        small: 4,
        medium: 6,
        large: 12,
        /** Use this border radius for pill shaped elements */
        full: 9999,
        default: 4
      }
    }
  },
  pattern: {
    size: {
      overlay: {
        height: {
          small: 256,
          medium: 320,
          large: 432,
          xlarge: 600
        },
        width: {
          xsmall: 192,
          small: 320,
          medium: 480,
          large: 640,
          xlarge: 960
        },
        borderRadius: 4,
        paddingBlock: {
          /** Vertical padding */
          condensed: 4,
          /** Vertical padding */
          normal: 12
        },
        padding: {
          condensed: 8,
          normal: 16
        },
        offset: 4
      },
      control: {
        xsmall: {
          /** Vertical padding */
          paddingBlock: 2,
          paddingInline: {
            /** Horizontal Padding */
            condensed: 4,
            /** Horizontal Padding */
            normal: 8,
            /** Horizontal Padding */
            spacious: 12
          },
          gap: 4,
          size: 24
        },
        small: {
          paddingInline: {
            /** Horizontal Padding */
            condensed: 6,
            /** Horizontal Padding */
            normal: 8
          },
          gap: 4,
          /** Vertical padding */
          paddingBlock: 4,
          size: 28
        },
        medium: {
          /** Vertical padding */
          paddingBlock: 6,
          gap: 8,
          paddingInline: {
            /** Horizontal Padding */
            condensed: 8,
            /** Horizontal Padding */
            normal: 12,
            /** Horizontal Padding */
            spacious: 16
          },
          size: 32
        },
        large: {
          /** Vertical padding */
          paddingBlock: 10,
          paddingInline: {
            /** Horizontal Padding */
            normal: 12,
            /** Horizontal Padding */
            spacious: 16
          },
          gap: 8,
          size: 40
        },
        xlarge: {
          gap: 8,
          /** Vertical padding */
          paddingBlock: 14,
          paddingInline: {
            /** Horizontal Padding */
            normal: 12,
            /** Horizontal Padding */
            spacious: 16
          },
          size: 48
        }
      },
      controlStack: {
        small: {
          gap: {
            condensed: 8,
            spacious: 16
          }
        },
        medium: {
          gap: {
            condensed: 8,
            spacious: 12
          }
        },
        large: {
          gap: {
            auto: 8,
            condensed: 8,
            spacious: 12
          }
        }
      },
      stack: {
        gap: {
          condensed: 8,
          normal: 16,
          spacious: 24
        },
        padding: {
          condensed: 8,
          normal: 16,
          spacious: 24
        }
      },
      spinner: {
        size: {
          xlarge: 32,
          large: 20,
          medium: 16,
          small: 14,
          xsmall: 12
        }
      },
      badge: {
        /** Vertical padding */
        paddingBlock: 2,
        /** Horizontal Padding */
        paddingInline: 2,
        gap: 4
      }
    }
  },
  responsive: {
    xl1440: {
      breakpoint: {
        xl: true,
        l: false,
        m: false,
        s: false,
        xs: false,
        xxs: false,
        sideNav: true,
        aside: true,
        panel: true,
        xlL: true,
        xlLM: true,
        xlLMS: true,
        xlLMSXs: true,
        sXsXxs: false,
        xsXxs: false,
        panelFlyout: false
      },
      breakpointScreen: {
        minWidth: 1440,
        maxWidth: 9999
      },
      grid: {
        column: 12,
        gutter: 16,
        margin: 32,
        minWidth: 1440,
        maxWidth: 9999,
        fixedWideGrid: {
          maxWidth: 1296
        },
        fixedNarrowGrid: {
          maxWidth: 864
        }
      }
    },
    l1024: {
      breakpoint: {
        xl: false,
        l: true,
        m: false,
        s: false,
        xs: false,
        xxs: false,
        sideNav: true,
        aside: true,
        panel: true,
        xlL: true,
        xlLM: true,
        xlLMS: true,
        xlLMSXs: true,
        sXsXxs: false,
        xsXxs: false,
        panelFlyout: false
      },
      breakpointScreen: {
        minWidth: 1024,
        maxWidth: 1440
      },
      grid: {
        column: 12,
        gutter: 16,
        margin: 32,
        minWidth: 1440,
        maxWidth: 1439,
        fixedWideGrid: {
          maxWidth: 1296
        },
        fixedNarrowGrid: {
          maxWidth: 864
        }
      }
    },
    m768: {
      breakpoint: {
        xl: false,
        l: false,
        m: true,
        s: false,
        xs: false,
        xxs: false,
        sideNav: true,
        aside: false,
        panel: false,
        xlL: false,
        xlLM: true,
        xlLMS: true,
        xlLMSXs: true,
        sXsXxs: false,
        xsXxs: false,
        panelFlyout: true
      },
      breakpointScreen: {
        minWidth: 768,
        maxWidth: 1024
      },
      grid: {
        column: 12,
        gutter: 16,
        margin: 32,
        minWidth: 1024,
        maxWidth: 1023,
        fixedWideGrid: {
          maxWidth: 1296
        },
        fixedNarrowGrid: {
          maxWidth: 864
        }
      }
    },
    s480: {
      breakpoint: {
        xl: false,
        l: false,
        m: false,
        s: true,
        xs: false,
        xxs: false,
        sideNav: true,
        aside: false,
        panel: false,
        xlL: false,
        xlLM: false,
        xlLMS: true,
        xlLMSXs: true,
        sXsXxs: true,
        xsXxs: false,
        panelFlyout: true
      },
      breakpointScreen: {
        minWidth: 480,
        maxWidth: 768
      },
      grid: {
        column: 6,
        gutter: 12,
        margin: 16,
        minWidth: 768,
        maxWidth: 767,
        fixedWideGrid: {
          maxWidth: 1296
        },
        fixedNarrowGrid: {
          maxWidth: 864
        }
      }
    },
    xs320: {
      breakpoint: {
        xl: false,
        l: false,
        m: false,
        s: false,
        xs: true,
        xxs: false,
        sideNav: false,
        aside: false,
        panel: false,
        xlL: false,
        xlLM: false,
        xlLMS: false,
        xlLMSXs: true,
        sXsXxs: true,
        xsXxs: true,
        panelFlyout: true
      },
      breakpointScreen: {
        minWidth: 320,
        maxWidth: 480
      },
      grid: {
        column: 2,
        gutter: 12,
        margin: 16,
        minWidth: 480,
        maxWidth: 479,
        fixedWideGrid: {
          maxWidth: 1296
        },
        fixedNarrowGrid: {
          maxWidth: 864
        }
      }
    }
  }
};

export default tokens;
